module.exports = __webpack_public_path__ + "static/media/TO.bd1b1212.svg";